<template>
  <div class="ui right aligned container">
    <button @click="addConfig" class="ui primary icon button">Add</button>
    <button @click="refresh" class="ui primary icon button"><i class="sync icon"></i></button>

    <div class="table-wrap">
      <vuetable ref="vuetable" api-url="/config" dataPath="" :fields="fields">
        <template scope="props" slot="actions">
          <i @click="editConfig(props.rowData)" class="edit link icon"></i>
        </template>
      </vuetable>
    </div>

    <Modal v-model="modal">
      <template slot="title">
        {{title}}
      </template>
      <form class="ui form">
        <div class="required field">
          <label>名字</label>
          <input name="name" type="text" v-model="config.name">
        </div>
        <div class="required field">
          <label>值</label>
          <input name="value" type="text" v-model="config.value">
        </div>
      </form>
      <template slot="actions">
        <div @click="onCancel" class="ui cancel button">取消</div>
        <div @click="onSubmit" class="ui positive button">提交</div>
      </template>
    </Modal>

  </div>
</template>

<script>
  import axios from 'axios';
  import Vuetable from '../../table/Vuetable.vue';
  import Modal from "../../components/Modal";

  export default {
    name: "ConfigAdmin",
    components: {
      Vuetable,
      Modal,
    },
    data() {
      return {
        modal: false,
        config: {
          name: '',
          value: '',
        },
        title: '添加',
        fields: [
          {name: 'name', title: '名字', width: '25%'},
          {name: 'value', title: '值', titleClass: 'cell-ellipsis', dataClass: 'cell-ellipsis'},
          {name: '__slot:actions', title: '操作', width: '80px'},
        ],
      };
    },
    methods: {
      refresh: function () {
        this.$refs.vuetable.reload();
      },
      editConfig(config) {
        this.config = {
          name: config.name,
          value: config.value,
        };
        this.title = '编辑';
        this.modal = true;
      },
      addConfig() {
        this.title = '添加';
        this.modal = true;
      },
      onCancel() {
        if (this.config.name) {
          this.config = {};
        }
        this.modal = false;
      },
      onSubmit() {
        if (!this.config.name || !this.config.value) {
          return;
        }
        axios.post('/config', this.config).then(() => {
          this.config = {};
          this.modal = false;
          this.refresh();
        }).catch((error) => {
          console.log(error);
        });
      },
    }
  };
</script>

<style>
/* 长值(cookie 等)不换行会把表格撑出容器，固定布局下截断显示，操作列始终可见 */
.table-wrap {
  overflow-x: auto;
}

.table-wrap table {
  table-layout: fixed;
}

.table-wrap .cell-ellipsis {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
